import styled from 'styled-components';
import { cvBreakpoint768 } from '@carvana/theme';
import { WizardHeading, WizardText } from '../../document-wizard-modal.styles';

export const DocumentSelectWrapper = styled.div`
  background-color: ${props => props.theme.carvana.gray.background};
  display: flex;
  flex: 1;
  padding: 120px 28px 0;

  @media (min-width: ${cvBreakpoint768}px) {
    padding: 44px;
  }
`;

export const DocumentSelectHeading = styled(WizardHeading)`
  font-size: 24px;
  margin-bottom: 14px;
  text-align: center;
`;

export const DocumentSelectSubheading = styled(WizardText)`
  text-align: center;
`;

export const DocumentSelectText = styled.p`
  color: ${props => props.theme.carvana.blue.dark};
  font-size: 14px;
`;

export const DragDropText = styled(DocumentSelectText)`
  display: none;

  @media (min-width: ${cvBreakpoint768}px) {
    display: block;
    margin-top: 60px;
  }
`;

export const FileSelectorWrapper = styled.div`
  margin: 30px 0;
`;

export const ErrorText = styled.p`
  color: ${props => props.theme.carvana.red.primary};
  font-size: 14px;
  transform: translateY(16px);
`;